"use client";

import React from "react";

import QuestionLayout from "@/app/layout/question";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";

import PMIDescriptionSection from "./components/description-section";
import PMIFormSection from "./components/form-section";
import usePMIHook from "./hook/private-medical-insurance.hook";
import { usePMIContext } from "./provider/private-medical-insurance.provider";

function PMI() {
  const { cmsData, scrollRefArray } = usePMIContext();
  const { ctaButtonText } = cmsData.personalMedicalQuestionArea[0];
  const {
    isFilledAllTraveler,
    isFooterLoading,
    isEditFlow,
    handleOptionSelect,
    handleBackButton,
    handleContinueButton,
  } = usePMIHook();
  const { current } = useWizard();
  const isShowBackButton = false;
  return (
    <div>
      <QuestionLayout
        footer={{
          isHideFooterBack: isShowBackButton ?? false,
          isLoading: isFooterLoading,
          isDisabledBack: false,
          isDisabledContinue: !isFilledAllTraveler,
          footerActionBack: () => {
            handleBackButton();
          },
          footerActionContinue: () => {
            handleContinueButton();
          },
          id: "pmi-footer",
          ctaButtonText: ctaButtonText ?? "Continue",
        }}
        formSection={<PMIFormSection onOptionSelect={handleOptionSelect} />}
        descriptionContent={<PMIDescriptionSection />}
        progressBarPercent={current.progressBarPercentage ?? 57}
        scrollRefs={scrollRefArray}
      />
    </div>
  );
}

export default PMI;
